import { ReactElement } from 'react';
import { TenantPackageInclude } from '~/tenants/common/package';
import { McmDroneType } from '~/tenants/mcm/performable/drone/McmDroneConfig';
import { usePackageFormContext } from '~/components/performable/PackageForm';
import McmPhotoJob from '~/tenants/mcm/performable/photo/McmPhotoJob';
import { McmOrderContext } from '~/tenants/mcm/model/McmOrder';
import { McmPhotoType } from '~/tenants/mcm/performable/photo/McmPhotoConfig';
import McmDroneJob from '~/tenants/mcm/performable/drone/McmDroneJob';
import McmVideoJob from '~/tenants/mcm/performable/video/McmVideoJob';
import { McmVideoType } from '~/tenants/mcm/performable/video/McmVideoConfig';

export function McmVideoInclude(props: { type: McmVideoType }): ReactElement {
  const context = usePackageFormContext<McmOrderContext>();
  const calc = McmVideoJob.calculate(context.orderContext, props.type);

  const name = `${calc.name} (${calc.duration})`;

  return <TenantPackageInclude name={name} image="tenant/bre/cinematic/thumbnail.jpg" />;
}

export function McmDayToNightInclude(): ReactElement {
  return <TenantPackageInclude name="Day to Night Transitions" image="tenant/bre/dusk/thumbnail.jpg" />;
}

export function McmSocialInclude(): ReactElement {
  return <TenantPackageInclude name="Social Media Edit" image="tenant/bre/social/social.png" />;
}

export function McmPhotoInclude(): ReactElement {
  const context = usePackageFormContext<McmOrderContext>();

  const calc = McmPhotoJob.calculatePhotos(context.orderContext, McmPhotoType.INTERIOR_EXTERIOR);

  return (
    <TenantPackageInclude
      name={`${calc.range} Interior + Exterior Photos`}
      image="tenant/bre/photos/thumbnail_v3.jpg"
    />
  );
}

export function McmDroneInclude({ type }: { type: McmDroneType }): ReactElement {
  const name = McmDroneJob.name(type);

  return <TenantPackageInclude name={name} image="tenant/bre/aerial/thumbnail.jpg" />;
}

export function McmDroneTwilightInclude(): ReactElement {
  return <TenantPackageInclude name="Twilight (Drone Stills)" image="tenant/bre/twilight/thumbnail.jpg" />;
}

export function McmVirtualTwilightInclude(): ReactElement {
  return <TenantPackageInclude name="Virtual Twilight" image="tenant/bre/twilight/thumbnail.jpg" />;
}

export function McmMicrositeInclude(): ReactElement {
  return <TenantPackageInclude name="Single Property Website" image="tenant/bre/website/thumbnail_v2.jpg" />;
}
